import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from "../../../../../Config/apiClient"

import "./ChangePassword.scss";

import { isValidPassword } from '../../../../../Utils/Validations/validatePassword';
import { FIELD_MAX_LENGTHS } from '../../Utils/Constants';
import Loader from '../../../../../Context/Loader/Loader';
import { showErrorToast } from '../../../../../Context/Toaster/Toaster';
import PasswordTooltip from '../../../../../Utils/PasswordToolTip/PasswordToolTip';
import { getFirstPermittedRoute } from '../../Services/NavigationList';

const signInPath = process.env.REACT_APP_TC_SIGNIN_BASE_PATH;;

const ChangePassword = () => {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const passwordWrapperRef = useRef(null);
    const [isPasswordFocused, setIsPasswordFocused] = useState(false);
    const navigate = useNavigate();

    const toggleNewPasswordVisibility = () => setShowNewPassword(!showNewPassword);
    const toggleConfirmPasswordVisibility = () => setShowConfirmPassword(!showConfirmPassword);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (passwordWrapperRef.current && !passwordWrapperRef.current.contains(event.target)) {
                setIsPasswordFocused(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const validate = () => {
        const newErrors = {};
        const newPwdCheck = isValidPassword(newPassword);

        if (!newPassword) {
            newErrors.newPassword = 'New Password is required.';
        } else if (!newPwdCheck.valid) {
            newErrors.newPassword = "Password doesn't meet the required criteria.";
        }

        if (!confirmPassword) {
            newErrors.confirmPassword = 'Confirm Password is required.';
        } else if (newPassword !== confirmPassword) {
            newErrors.confirmPassword = 'Passwords do not match.';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        setLoading(true);
        try {
            const response = await apiClient.put(`${signInPath}/change-password`, { newPassword, confirmPassword });

            if (response.data.status === 'SUCCESS') {
                const firstPath = getFirstPermittedRoute();
                if (firstPath) {
                    navigate(firstPath);
                } else {
                    navigate("/access-denied")
                }
            } else {
                showErrorToast(response.data.message);
            }
        } catch (err) {
            const msg = err.response ? err.response.data.message : err.message;
            console.error(msg);
            showErrorToast(msg);
        } finally {
            setLoading(false);
        }
    };


    const renderPasswordField = (label, value, setValue, show, toggle, name, error) => {
        const isNewPassword = name === 'newPassword';

        return (
            <div className="hf-split c-name" style={{ position: 'relative' }}>
                <label className="fi-label">{label}</label>
                <div className={`password-box pass-input ${isNewPassword && isPasswordFocused ? 'focused' : ''}`} style={{ position: 'relative' }} ref={isNewPassword ? passwordWrapperRef : null}>
                    {isNewPassword && isPasswordFocused && value === '' && <PasswordTooltip />}

                    <input type={show ? 'text' : 'password'} className={`common-input ${error ? 'error' : ''}`} value={value} maxLength={FIELD_MAX_LENGTHS.password} required
                        onChange={(e) => { setValue(e.target.value); setErrors((prev) => ({ ...prev, [name]: '' })); }}
                        onFocus={() => isNewPassword && setIsPasswordFocused(true)}
                        onBlur={() => isNewPassword && setIsPasswordFocused(false)}
                    />
                    <i className={`fa field-icon ${show ? 'fa-eye' : 'fa-eye-slash'}`} onClick={toggle} style={{ position: 'absolute', top: '50%', right: '10px', transform: 'translateY(-50%)', cursor: 'pointer', }} />
                </div>
                <span className={`error-text ${error ? 'active' : ''}`}>{error || ' '}</span>
            </div>
        );
    };

    return (
        <div className="form-cvr block-wraper">
            <div className="h-form signin-form">
                <div className="otp-header">
                    <h1>Change Password</h1>
                </div>

                <form className="hform-inner-small" onSubmit={handleSubmit} noValidate>
                    {renderPasswordField(
                        'New Password',
                        newPassword,
                        setNewPassword,
                        showNewPassword,
                        toggleNewPasswordVisibility,
                        'newPassword',
                        errors.newPassword
                    )}

                    {renderPasswordField(
                        'Confirm Password',
                        confirmPassword,
                        setConfirmPassword,
                        showConfirmPassword,
                        toggleConfirmPasswordVisibility,
                        'confirmPassword',
                        errors.confirmPassword
                    )}

                    <div className="fp-field">
                        <button className="h-btn center-btn" type="submit" disabled={loading}>
                            {loading ? <Loader /> : 'Update'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ChangePassword;
